// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import PlusSquareOutlinedSvg from "@ant-design/icons-svg/lib/asn/PlusSquareOutlined";
import AntdIcon from "../components/AntdIcon";
const PlusSquareOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: PlusSquareOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    PlusSquareOutlined.displayName = "PlusSquareOutlined";
}
export default /*#__PURE__*/ React.forwardRef(PlusSquareOutlined);
